import React, { useState, useEffect, useRef } from 'react';
import { ChevronDown, Server, Globe, Shield, Zap, Code, Users, X, Menu } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import SplashScreenH from './SplashScreenH';
import ReactDOM from 'react-dom';
import { EXTERNAL_URLS } from '../config';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [, setActiveMobileSection] = useState('');
  const [scrollPosition, setScrollPosition] = useState(0);
  const mobileMenuRef = useRef(null);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const servicesRef = useRef(null);
  const navRef = useRef(null);
  const [showSplash, setShowSplash] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (isMenuOpen) {
      setScrollPosition(window.pageYOffset);
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    } else {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (scrollPosition) {
        window.scrollTo(0, scrollPosition);
      }
    }
    const handleClickOutside = (event) => {
      if (mobileMenuRef.current && !mobileMenuRef.current.contains(event.target) && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === 'Escape' && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }
    return () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isMenuOpen, scrollPosition]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (servicesRef.current && !servicesRef.current.contains(event.target)) {
        setIsServicesOpen(false);
      }
    }
    if (isServicesOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isServicesOpen]);

  const handleLinkClick = (sectionId) => {
    // Se for o menu Planos, ajuste para a página correta
    if (sectionId === 'planos') {
      if (window.location.pathname === '/wordpress') {
        const el = document.getElementById('planos-wordpress');
        if (el) {
          const headerHeight = 80;
          const elementPosition = el.offsetTop - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
        setActiveMobileSection('planos-wordpress');
        setIsMenuOpen(false);
        return;
      }
    }
    // Se for o menu Recursos, ajuste para a página correta
    if (sectionId === 'recursos') {
      if (window.location.pathname === '/wordpress') {
        const el = document.getElementById('recursos-wordpress');
        if (el) {
          const headerHeight = 80;
          const elementPosition = el.offsetTop - headerHeight;
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
        setActiveMobileSection('recursos-wordpress');
        setIsMenuOpen(false);
        return;
      }
    }
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.offsetTop - headerHeight;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
      setActiveMobileSection(sectionId);
    }
    setIsMenuOpen(false);
  };

  return (
    <>
      {isServicesOpen && ReactDOM.createPortal(
        <div
          className="fixed inset-0 bg-black bg-opacity-60 z-40"
          style={{ pointerEvents: 'auto' }}
          onClick={() => setIsServicesOpen(false)}
        ></div>,
        document.body
      )}
      <nav ref={navRef} className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-gray-900/90 backdrop-filter backdrop-blur-lg py-3 shadow-lg shadow-purple-900/20' : 'bg-transparent py-6'}`}>
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center">
            <Link to="/" className="flex items-center group" style={{ textDecoration: 'none' }}>
              <div className="mr-2 text-purple-500 group-hover:scale-110 transition-transform">
                <Server size={28} />
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-indigo-400 text-transparent bg-clip-text group-hover:text-purple-400 transition-colors">
                Hostul
              </span>
            </Link>
          </div>
          <div className="hidden md:flex space-x-8 items-center">
            <button onClick={() => handleLinkClick('recursos')} className="text-gray-300 hover:text-white transition-colors">Recursos</button>
            <button onClick={() => handleLinkClick('planos')} className="text-gray-300 hover:text-white transition-colors">Planos</button>
            <button onClick={() => handleLinkClick('depoimentos')} className="text-gray-300 hover:text-white transition-colors">Depoimentos</button>
            <button onClick={() => handleLinkClick('contato')} className="text-gray-300 hover:text-white transition-colors">Contato</button>
            <div className="relative" ref={servicesRef}>
              <button onClick={() => setIsServicesOpen((v) => !v)} className="text-gray-300 hover:text-white transition-colors flex items-center gap-1 px-3 py-2 rounded-lg hover:bg-purple-700/10 focus:outline-none">Serviços <ChevronDown size={16} /></button>
              {isServicesOpen && (
                <>
                <div className="absolute right-0 mt-2 w-72 bg-gray-900 border border-gray-800 rounded-xl shadow-xl z-50 p-4 animate-fade-in">
                  <div className="grid gap-3">
                    <div className="font-semibold text-purple-400 mb-2">Nossos Serviços</div>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800" onClick={() => {
                      navigate('/');
                      setIsServicesOpen(false);
                      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
                    }}><Server size={18} /> Hospedagem de Sites</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800" onClick={() => { navigate('/wordpress'); setIsServicesOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Globe size={18} /> Hospedagem WordPress</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800" onClick={() => { navigate('/email-profissional'); setIsServicesOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Shield size={18} /> Email Profissional</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800"><Code size={18} /> Criador de Sites Inteligente</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800" onClick={() => { navigate('/dominios'); setIsServicesOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Users size={18} /> Registrar Domínio</button>
                    <button
                      className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-800"
                      style={{ textDecoration: 'none' }}
                      onClick={() => {
                        setShowSplash(true);
                        setIsServicesOpen(false);
                      }}
                    >
                      <Code size={18} /> Engenharia de Sites
                    </button>
                    <div className="mt-2 text-xs text-gray-400">Descubra soluções exclusivas para seu negócio!</div>
                  </div>
                </div>
              </>
            )}
            </div>
          </div>
          <div className="hidden md:flex space-x-4">
            <a href={EXTERNAL_URLS.authBase} className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-opacity-50 bg-white text-gray-800 hover:shadow-md focus:ring-gray-300">Entrar</a>
            <a href={EXTERNAL_URLS.register} className="px-6 py-3 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-opacity-50 bg-gradient-to-r from-purple-600 to-indigo-600 text-white hover:shadow-lg hover:shadow-purple-500/40 focus:ring-purple-500">Registrar</a>
          </div>
          <div className="md:hidden">
            <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="p-2 rounded-full bg-purple-600/20 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 hover:bg-purple-600/30 transition-all z-60" aria-label={isMenuOpen ? "Fechar menu" : "Abrir menu"}>{isMenuOpen ? (<X size={24} className="text-white" />) : (<Menu size={24} className="text-white" />)}</button>
          </div>
        </div>
        {isMenuOpen && (
          <div className="md:hidden fixed inset-0 bg-gray-900/95 backdrop-filter backdrop-blur-lg z-50 flex flex-col overscroll-none" ref={mobileMenuRef} style={{ top: `${scrollPosition}px` }}>
            <div className="flex items-center justify-between px-4 py-4 border-b border-gray-800">
              <Link to="/" className="flex items-center group" style={{ textDecoration: 'none' }} onClick={() => setIsMenuOpen(false)}>
                <div className="mr-2 text-purple-500 group-hover:scale-110 transition-transform">
                  <Server size={24} />
                </div>
                <span className="text-xl font-bold bg-gradient-to-r from-purple-400 to-indigo-400 text-transparent bg-clip-text group-hover:text-purple-400 transition-colors">Hostul</span>
              </Link>
              <button onClick={() => setIsMenuOpen(false)} className="p-2 rounded-full bg-gray-800 hover:bg-gray-700 transition-colors" aria-label="Fechar menu"><X size={20} className="text-white" /></button>
            </div>
            <div className="flex-1 overflow-y-auto p-4">
              <div className="space-y-2 mb-8">
                <button onClick={() => handleLinkClick('recursos')} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Zap size={18} /><span className="font-medium">Recursos</span></button>
                <button onClick={() => handleLinkClick('planos')} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Globe size={18} /><span className="font-medium">Planos</span></button>
                <button onClick={() => handleLinkClick('depoimentos')} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Users size={18} /><span className="font-medium">Depoimentos</span></button>
                <button onClick={() => handleLinkClick('contato')} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Code size={18} /><span className="font-medium">Contato</span></button>
                <button onClick={() => setIsServicesOpen((v) => !v)} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Shield size={18} /><span className="font-medium">Serviços</span></button>
                {isServicesOpen && (
                  <div className="bg-gray-800 rounded-lg p-3 mb-2 animate-fade-in">
                    <div className="font-semibold text-purple-400 mb-2">Nossos Serviços</div>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700" onClick={() => {
                      navigate('/');
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
                    }}><Server size={18} /> Hospedagem de Sites</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700" onClick={() => { navigate('/wordpress'); setIsServicesOpen(false); setIsMenuOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Globe size={18} /> Hospedagem WordPress</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700" onClick={() => { navigate('/email-profissional'); setIsServicesOpen(false); setIsMenuOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Shield size={18} /> Email Profissional</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700"><Code size={18} /> Criador de Sites Inteligente</button>
                    <button className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700" onClick={() => { navigate('/dominios'); setIsServicesOpen(false); setIsMenuOpen(false); setTimeout(() => window.scrollTo(0, 0), 50); }}><Users size={18} /> Registrar Domínio</button>
                    <Link to="/engenharia" className="flex items-center gap-2 text-left text-white hover:text-purple-400 transition-colors p-2 rounded-lg hover:bg-gray-700" style={{ textDecoration: 'none' }} onClick={() => {
                      navigate('/dominios');
                      setIsServicesOpen(false);
                      setIsMenuOpen(false);
                    }}><Code size={18} /> Engenharia de Sites</Link>
                    <div className="mt-2 text-xs text-gray-400">Descubra soluções exclusivas para seu negócio!</div>
                  </div>
                )}
                <button onClick={() => { setShowSplash(true); setIsMenuOpen(false); setIsServicesOpen(false); }} className="w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 text-gray-300 hover:bg-gray-800 hover:text-white"><Code size={18} /><span className="font-medium">Engenharia de Sites</span></button>
              </div>
              <div className="space-y-3">
                <a href={EXTERNAL_URLS.authBase} className="block w-full py-3 px-4 rounded-lg border border-gray-600 text-white font-medium hover:bg-gray-800 transition-colors">Entrar</a>
                <a href={EXTERNAL_URLS.register} className="block w-full py-3 px-4 rounded-lg bg-gradient-to-r from-purple-600 to-indigo-600 text-white font-medium hover:shadow-lg hover:shadow-purple-500/20 transition-all">Registrar</a>
              </div>
              <div className="mt-8 pt-6 border-t border-gray-800">
                <div className="flex justify-center space-x-6">
                  {/* Social icons aqui se desejar */}
                </div>
                <div className="mt-6 text-center text-sm text-gray-400">
                  <p>&copy; 2026 Hostul. Todos os direitos reservados.</p>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
      {showSplash && (
        <SplashScreenH
          show={showSplash}
          onFinish={() => {
            setShowSplash(false);
            navigate('/engenharia');
          }}
        />
      )}
    </>
  );
} 
